import React, { useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import styled from 'styled-components'

import { useGoogleMapsContext } from 'contexts/GoogleMapsContext'
import { getPlaceImageUrl } from 'tripPlanner/hooks/getPlaceImageUrl'

const Image = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  object-fit: cover;
  object-position: center;
  width: 100%;
  height: 100%;
`

type Props = {
  placeId: string
  title: string
  placeholder?: React.ReactNode
}
function GoogleCardImage({ placeId, title, placeholder }: Props) {
  const [photoUrl, setPhotoUrl] = useState<string | null | undefined>(undefined)
  const { isLoaded, placesService } = useGoogleMapsContext()
  const [imageRef, imageInView] = useInView({
    triggerOnce: true, // Load it once and keep it loaded
    rootMargin: '200px', // Trigger 500px before the component is reached
  })

  useEffect(() => {
    if (!placesService || !imageInView) return
    const fetchImageUrl = async () => {
      const url = await getPlaceImageUrl(
        placesService,
        placeId,
        'all',
        640, // this will save us from having to request again in the summary card
      )
      setPhotoUrl(url)
    }
    fetchImageUrl()
  }, [placesService, placeId, imageInView])

  if (!isLoaded || photoUrl === undefined) return <div ref={imageRef}></div>

  if (photoUrl === null) return <>{placeholder}</>

  return <Image ref={imageRef} src={photoUrl} alt={title} />
}
export default GoogleCardImage
